import { render, staticRenderFns } from "./childrenLayout.vue?vue&type=template&id=48523586&scoped=true&"
import script from "./childrenLayout.vue?vue&type=script&lang=ts&"
export * from "./childrenLayout.vue?vue&type=script&lang=ts&"
import style0 from "./childrenLayout.vue?vue&type=style&index=0&id=48523586&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48523586",
  null
  
)

export default component.exports